"use client";

import { cn } from "@oreme/ui";
import { cva } from "class-variance-authority";
import React, { type HTMLAttributes, type ReactElement } from "react";
import { TagListItem } from "@/components";
import type { ObservatoryTag } from "@/types";
import { useLocale } from "next-intl";

interface TagListProps extends HTMLAttributes<HTMLUListElement> {
  data: ObservatoryTag[];
}

const tagListVariants = cva("flex flex-wrap gap-0.5");

function TagList({ className, data }: Readonly<TagListProps>): ReactElement {
  const locale = useLocale();
  const sortedData = data.toSorted((a, b) =>
    a.tag.name[locale].localeCompare(b.tag.name[locale]),
  );

  return (
    <ul className={cn(tagListVariants({ className }))}>
      {sortedData.map((item): ReactElement => {
        const tag = item.tag;
        return (
          <li key={tag.id}>
            <TagListItem tag={tag} />
          </li>
        );
      })}
    </ul>
  );
}

export { TagList, type TagListProps };
